module.exports = __webpack_public_path__ + "img/cardscan.5eaa686b.jpg";